import {Component, inject, OnInit} from '@angular/core';
import {GET_LANDING_STATS} from "../../../portal-home/portal-home";
import {Apollo} from "apollo-angular";

@Component({
  selector: 'app-service-statistics-banner',
  templateUrl: './service-statistics-banner.component.html',
  standalone: false,
  styleUrl: './service-statistics-banner.component.scss'
})
export class ServiceStatisticsBannerComponent implements OnInit {
  idadiYaHuduma = 127;
  idadiYaTaasisi = 105;
  hudumaZilizoOmbwa = 247;

  serviceCount: number = 0;  // Initial value, replace with your actual value
  governmentServices: number = 0
  vsitCount: number = 0
  feedBackCount: number = 0
  landingStats: {
    totalServices?: number
    totalCitizens?: number
    totalCitizenFeedbacks?: number
  }

  apollo = inject(Apollo);

  getLandingStats() {
    this.apollo
      .query({
        query: GET_LANDING_STATS,
        fetchPolicy: 'network-only',
      })
      .toPromise()
      .then((data) => {
        let result: any = Object.values(data)[0];
        result = result.getLandingStats;
        if (result?.response.code == '9000') {
          this.landingStats = result.data;
          this.updateAnimatedValue()
        }
      })
  }

  ngOnInit() {
    this.getLandingStats();
  }

  updateAnimatedValue() {
    // Simulate updating the value over time (e.g., with a timer)
    setInterval(() => {
      if (this.serviceCount >= this.landingStats?.totalServices) {
        this.serviceCount = this.landingStats?.totalServices
      } else {
        this.serviceCount += 10; // Adjust this based on your actual logic
      }
    }, 100);
    setInterval(() => {
      if (this.governmentServices >= 220) {
        this.governmentServices = 220
      } else {
        this.governmentServices += 10; // Adjust this based on your actual logic
      }
    }, 100);

    setInterval(() => {
      if (this.vsitCount >= this.landingStats?.totalCitizens) {
        this.vsitCount = this.landingStats?.totalCitizens
      } else {
        this.vsitCount += 20; // Adjust this based on your actual logic
      }
    }, 100);

    setInterval(() => {
      if (this.feedBackCount >= this.landingStats?.totalCitizenFeedbacks) {
        this.feedBackCount = this.landingStats?.totalCitizenFeedbacks
      } else {
        this.feedBackCount += 20; // Adjust this based on your actual logic
      }
    }, 100);
  }

}
